import { Asset, Registration, TrainingEventSession } from '@dtu/types';

export interface BaseCalendarRegistration {
  registrationId: Registration['id'];
  eventName: Asset['name'];
  startTime: Registration['startTime'];
  endTime: Registration['endTime'];
  sessions?: TrainingEventSession[];
  urlPath?: string;
}

export interface CalendarEnrollments {
  id: number;
  name: string;
  sessions: CalendarSession[];
}

export interface CalendarSession {
  id: number;
  event_id: number;
  name: string;
  start_time: string;
  end_time: string;
  url_path: string;
}
